import type { SendEventParams } from '~/shared/analytix'
import type { GeneralParameters } from '../../general/parameters/general'

import { Analytix } from '~/shared/analytix'
import { AnalytixEvent } from '../../general/event'
import { Gate, seeds } from '../../general/gate'
import { SnapshotMap } from '../../general/snapshot-map'

const SNAPSHOTS_TO_KEEP = 1

export type SearchParameters = SendEventParams.Search

/** searchContentType values for hybrid search analytics */
export const SEARCH_CONTENT_TYPE = {
  voice: 'voice',
  manual: 'manual',
  autosuggest: 'autosuggest',
  recent: 'recent',
  auto: 'auto',
} as const

export type SearchContentType =
  (typeof SEARCH_CONTENT_TYPE)[keyof typeof SEARCH_CONTENT_TYPE]

/**
 * Event wrapper for `search`.
 * Uses session gate to prevent pre-session delivery.
 */
export class SearchEvent extends AnalytixEvent<SearchParameters> {
  name = 'search'
  group = 'search'
  parameters = new SnapshotMap<SearchParameters>(SNAPSHOTS_TO_KEEP)
  sender = Analytix.prototype.sendSearchEvent

  gates = [Gate.Uses(seeds.session)]

  constructor(inputString: string, searchContentType: SearchContentType) {
    super()
    this.parameters
      .set('inputString', inputString)
      .set('searchContentType', searchContentType)
    this.verify()
  }

  validate(): false | [GeneralParameters, SearchParameters] {
    const inputString = this.parameters.get('inputString')
    if (inputString == null || String(inputString).trim() === '') {
      this.abort()
      return false
    }
    return [
      Object.fromEntries(this.general),
      Object.fromEntries(this.parameters),
    ]
  }
}
